import { notImplemented, mod97CheckSum } from "../utils/general-helper";
import { IRegionFunctions, ParsedAccount } from "./region-functions";

const regionFunctionsES: () => IRegionFunctions = () => {
	const validPhoneNrExpression = RegExp(/^(\+34|9)\d{2,3}[- ]?\d{3}[- ]?\d{3}$/);
	const basicIbanStructureRegEx = RegExp(/^(?=.{15,34}$)[A-Z]{2}[A-Z0-9]+$/);
	//as we dont have any validation for this country we sett max length to DB max length
	const accountNumberMaxLength = 50;

	const validPhoneNumber = (phoneNumber: string): boolean => validPhoneNrExpression.test(phoneNumber);

	const formatPhoneNumber = (_phoneNumber: string): string => {
		return notImplemented();
	};

	const validateAccountNumber = (accountNumber: string): boolean => {
		if (accountNumber.length < 1) return true;
		return accountNumber.length > 0 && accountNumber.length <= accountNumberMaxLength;
	};

	const getBankAccountMeta = (_accountNrIncludingClearing?: string) => {
		return {
			clearingNumberLength: 0,
			accountNumberMaxLength,
		};
	};

	const parseAccountNumber = (accountNrIncClearing: string): ParsedAccount => {
		return { clearingNumber: "", accountNumber: accountNrIncClearing };
	};

	const formatAccountNumber = (clearingNr: string, accountNr: string) => {
		return clearingNr + accountNr;
	};

	const validateIban = (IBAN: string, allowedCountryCodes?: string): boolean => {
		if (IBAN.length < 1) return true;
		if (allowedCountryCodes && allowedCountryCodes !== "") {
			const ibanCountryCode = IBAN.substring(0, 2);
			if (!allowedCountryCodes.split(",").some((countryCode) => countryCode === ibanCountryCode))
				return false;
		}
		IBAN = IBAN.replace(/[\s]+/g, "").toUpperCase();
		if (!basicIbanStructureRegEx.test(IBAN)) return false;

		const rearrangedIban = IBAN.slice(4) + IBAN.slice(0, 4);
		const convertedIban = rearrangedIban.replace(/[A-Z]/g, (char) => (char.charCodeAt(0) - 55).toString());

		return mod97CheckSum(convertedIban);
	};

	return {
		validateAccountNumber,
		validPhoneNumber,
		formatAccountNumber,
		validateIban,
		formatPhoneNumber,
		parseAccountNumber,
		bankAccountMeta: getBankAccountMeta,
	};
};

export const ESRegionFunctions = regionFunctionsES();
